import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import homeicon from '../assets/images/Home.svg';
import notificationsicon from '../assets/images/Notifications.svg';
import messageicon from '../assets/images/Messages.svg';
import collectionicon from '../assets/images/Collections.svg';
import subscriptionicon from '../assets/images/Subscriptions.svg';
import addcardicon from '../assets/images/Add_card.svg';
import profileicon from '../assets/images/profile.svg';
import moreicon from '../assets/images/More.svg';
import collection_popupicon from '../assets/images/Collections_b.svg';
import settingsicon from '../assets/images/Settings.svg';
import youcardicon from '../assets/images/Your_сards.svg';
import becomecreatoricon from '../assets/images/Become_a_creator.svg';
import supporticon from '../assets/images/Help_and_support.svg';
import darkmodeicon from '../assets/images/Dark_mode.svg';
import login_icon from '../assets/images/My_profile.svg';
import default_user from '../assets/images/user_profile_bg.svg';
import config from '../config/config';

const ModalOverlay = ({ show, onClick }) => {
  return show ? <div className="modal-backdrop fade show" onClick={onClick}></div> : null;
};

const MainSidebar = () => {
  const [showModal, setShowModal] = useState(false);
  const [userDetails, setUserDetails] = useState(null); // State to store user details
  const navigate = useNavigate();

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div className="nav_menu_side without_login_sidebar">
      <div className="profile_icons">
        <a onClick={handleShow} href="javascript:void(0)" className="profile_with_text contact_deafult_user">
          <img src={default_user} />
        </a>                 
      </div>
      <div className="left_nav_bar_main">
        <ul>
          <li>
            <Link to="/">
              <div className="svg_menu"> 
                <img src={homeicon} alt="" />                
              </div>
              Home
            </Link>
          </li>
          <li>
            <a onClick={handleShow} href="javascript:void(0)">
              <div className="svg_menu">
                <img src={moreicon} alt="" />
              </div>
              More
            </a>
          </li>
        </ul>
      </div>

      {/* Restore Access Modal */}
      {showModal && (
        <>
          <ModalOverlay show={showModal} onClick={handleClose} />
          <div className="modal top-right fade show" style={{ display: 'block' }} id="ProfileModel" aria-labelledby="ProfileModelLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">

                  <div className="contact_user_pic">

                    <img src={default_user} />

                  </div>

                  <button type="button" className="btn-close-popup" onClick={handleClose} aria-label="Close">
                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 49L49 5" stroke="#8A96A3" strokeWidth="7.52867" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M49 49L5 5" stroke="#8A96A3" strokeWidth="7.52867" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="popup_menu">
                    <ul>
                      <li>
                        <Link to="/help">
                          <div className="svg_menu">
                            <img src={supporticon} alt=""/>
                          </div>  
                          Help and support 
                        </Link>
                      </li>
                      <hr className="poup_hor_line"/>
                      <li>
                        <Link to="/">
                          <div className="svg_menu">
                            <img src={login_icon} alt=""/>
                          </div>  
                          Login
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </>
      )}
    </div>
  );
};

export default MainSidebar;
